/**
 * Push bildirimi anahtarları.
 *
 * NEDEN AYRI DOSYA: `fcmService.ts` bu iki değeri `import.meta.env`den
 * okuyordu. ts-jest `import.meta`yı derleyemiyor, bu yüzden fcmService
 * TEST ORTAMINDA HİÇ IMPORT EDİLEMİYORDU — "Must use import to load ES
 * Module" ile çöküyordu. 560 satırın testsiz kalmasının asıl sebebi
 * buydu; kimse yazmamış olması değil, yazılamıyor olması.
 *
 * Okuma buraya taşındı, ifadeler DEĞİŞMEDİ (`|| ''` ve `.trim()` dahil).
 * `src/test/setup.ts` bu modülü sahteliyor; artık fcmService import
 * edilebiliyor.
 *
 * Aynı desen `lib/clientConfig.ts`te de var — orada sabitler statik olduğu
 * için sahteye gerek kalmamıştı, burada değer ortamdan geldiği için gerekiyor.
 */

/** Firebase Cloud Messaging VAPID anahtarı. */
export const VAPID_KEY = (import.meta.env.VITE_FIREBASE_VAPID_KEY || '').trim()

/** Web Push API fallback için ayrı VAPID public key. */
export const WEBPUSH_VAPID_KEY = (
  import.meta.env.VITE_WEBPUSH_VAPID_PUBLIC_KEY || ''
).trim()
